import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import SolutionSection from './components/SolutionSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import SEOSection from './components/SEOSection';
import CostOfDelayCalculator from './components/CostOfDelayCalculator';
import CTAFormSection from './components/CTAFormSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ProblemsSection />
        <SolutionSection />
        <TestimonialsSection />
        <FAQSection />
        <SEOSection />
        <CostOfDelayCalculator />
        <CTAFormSection />
      </main>
      <Footer />
    </>
  );
}